import { StepContainer } from '../components/StepContainer'
import { MultiSelect } from '../components/MultiSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { Struggle } from '../types/onboarding'

const options: { value: Struggle; label: string; emoji: string }[] = [
  { value: 'reading_labels', label: 'Reading Labels', emoji: '🏷️' },
  { value: 'hidden_phosphorus', label: 'Hidden Phosphorus', emoji: '🔍' },
  { value: 'eating_out', label: 'Eating Out', emoji: '🍽️' },
  { value: 'portion_sizes', label: 'Portion Sizes', emoji: '📏' },
  { value: 'potassium_foods', label: 'Potassium in Foods', emoji: '🍌' },
  { value: 'meal_ideas', label: 'Meal Ideas', emoji: '💡' },
  { value: 'sodium_limits', label: 'Sodium Limits', emoji: '🧂' },
  { value: 'fluid_tracking', label: 'Fluid Tracking', emoji: '💧' },
  { value: 'consistency', label: 'Staying Consistent', emoji: '📆' },
]

export function StrugglesStep() {
  const { data, updateData, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="What are your biggest struggles?"
      subtitle="Select up to 3"
      onContinue={() => goNext()}
      continueDisabled={data.struggles.length === 0}
    >
      <MultiSelect
        options={options}
        values={data.struggles}
        onChange={(values) => updateData({ struggles: values })}
        columns={3}
        max={3}
      />
    </StepContainer>
  )
}
